export default __webpack_public_path__ + "static/media/Arrow 1.90da2eab.svg";